var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 15.1663H5.9987C2.3787 15.1663 0.832031 13.6197 0.832031 9.99967V5.99967C0.832031 2.37967 2.3787 0.833008 5.9987 0.833008H9.33203C9.60536 0.833008 9.83203 1.05967 9.83203 1.33301C9.83203 1.60634 9.60536 1.83301 9.33203 1.83301H5.9987C2.92536 1.83301 1.83203 2.92634 1.83203 5.99967V9.99967C1.83203 13.073 2.92536 14.1663 5.9987 14.1663H9.9987C13.072 14.1663 14.1654 13.073 14.1654 9.99967V6.66634C14.1654 6.39301 14.392 6.16634 14.6654 6.16634C14.9387 6.16634 15.1654 6.39301 15.1654 6.66634V9.99967C15.1654 13.6197 13.6187 15.1663 9.9987 15.1663Z",
    fill: "#84858D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 7.16633H11.9987C9.7187 7.16633 8.83203 6.27967 8.83203 3.99967V1.333C8.83203 1.133 8.95203 0.946334 9.1387 0.873C9.32536 0.793 9.5387 0.839667 9.68536 0.979667L15.0187 6.313C15.1587 6.453 15.2054 6.673 15.1254 6.85967C15.0454 7.04633 14.8654 7.16633 14.6654 7.16633ZM9.83203 2.53967V3.99967C9.83203 5.71967 10.2787 6.16633 11.9987 6.16633H13.4587L9.83203 2.53967Z",
    fill: "#84858D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66797 9.16699H4.66797C4.39464 9.16699 4.16797 8.94033 4.16797 8.66699C4.16797 8.39366 4.39464 8.16699 4.66797 8.16699H8.66797C8.9413 8.16699 9.16797 8.39366 9.16797 8.66699C9.16797 8.94033 8.9413 9.16699 8.66797 9.16699Z",
    fill: "#84858D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33464 11.833H4.66797C4.39464 11.833 4.16797 11.6063 4.16797 11.333C4.16797 11.0597 4.39464 10.833 4.66797 10.833H7.33464C7.60797 10.833 7.83464 11.0597 7.83464 11.333C7.83464 11.6063 7.60797 11.833 7.33464 11.833Z",
    fill: "#84858D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.8f70340dac9fa747b3ac56e091f1b7c4.svg";
export { ForwardRef as ReactComponent };